import React from 'react';
import { makeStyles, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#523ee8',
    color: '#fff',
    width: '100%',
    borderRadius: 16,
    padding: '32px 64px',
    display: 'flex',
    alignItems: 'center',
  },
  addButton: {
    color: 'inherit',
    borderColor: '#fff',
    borderRadius: 32,
    minWidth: 235,
    height: 42,
  },
  push: {
    flexGrow: 1,
  },
  title: {
    margin: 8,
  },
  ['@media(max-width: 1000px)']: {
    root: {
      flexDirection: 'column',
    },
  },
});

export default function BannerView({ title, action, onActionClick, ...props }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="body1" className={classes.title}>
        {title}
      </Typography>
      <div className={classes.push} />
      <Button
        variant="outlined"
        className={classes.addButton}
        onClick={onActionClick}
        {...props}
      >
        {action}
      </Button>
    </div>
  );
}
